import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import VersionDisplay from '../common/infoDisplays/versionDisplay';
import ThemeSelectorFooter from '../theme/ThemeSelectorFooter';
import entityComposition from '../common/classes/entityComposition';
const Footer = props => {
  const {
    login: {
      customer,
      user
    }
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "card-footer small fixed-bottom"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4,
    className: "footer__left"
  }, "\xA9 ", moment().format('YYYY'), " TRU", ' · ', /*#__PURE__*/React.createElement(ThemeSelectorFooter, null)), /*#__PURE__*/React.createElement(Col, {
    xs: 4,
    style: {
      textAlign: 'center'
    }
  }, customer, " ", user && `> ${user.username}`), /*#__PURE__*/React.createElement(Col, {
    xs: 4,
    style: {
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(VersionDisplay, null)))));
};
Footer.propTypes = {
  login: PropTypes.shape({
    customer: PropTypes.string,
    user: PropTypes.shape({
      username: PropTypes.string
    })
  }).isRequired
};
export { Footer as TestFooter };
export default entityComposition(Footer, ['login']);